// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit Log Styles */

.audit-container {
  animation: fadeIn 0.3s ease;
}

.audit-container h1 {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border, rgba(255,255,255,.07));
}

.table-responsive {
  background-color: var(--bg-card, #0d0f1a);
  border: 1px solid var(--border, rgba(255,255,255,.07));
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.3);
  /* \`overflow: hidden\` recortaba la tabla ancha sin dar scroll: en un móvil la
     columna «Cambio» era inalcanzable. */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* En móvil cada registro se lee como ficha: etiqueta a la izquierda. */
@media (max-width: 768px) {
  /* La regla genérica de \`overrides.css\` da 560 px mínimos a las tablas de
     Bootstrap para que se puedan deslizar; aquí ya está apilada. */
  .audit-container .table-responsive > .table {
    min-width: 0;
  }

  .audit-container h1 {
    margin-bottom: 1rem;
    font-size: 1.3rem;
  }

  .table {
    min-width: 0;
  }

  .table thead {
    display: none;
  }

  .table tbody tr {
    display: block;
    margin-bottom: 0.65rem;
    border: 1px solid var(--border, rgba(255,255,255,.07));
    border-radius: 10px;
    background: var(--bg-card, #0d0f1a);
    overflow: hidden;
  }

  .table td {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.45rem 0.8rem !important;
    border: 0;
    border-bottom: 1px solid var(--border, rgba(255,255,255,.07));
    text-align: right;
  }

  .table td:last-child {
    border-bottom: 0;
  }

  .table td[data-label]::before {
    content: attr(data-label);
    flex: 0 0 auto;
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    text-align: left;
  }
}

.table {
  margin-bottom: 0;
  color: var(--text-primary, #e2e8f0);
}

.table thead {
  background-color: #1e293b;
  color: #e2e8f0;
}

.table-dark {
  background-color: #1e293b;
  color: #e2e8f0;
}

.table-dark th {
  border-color: #495057;
}

.table tbody tr {
  transition: background-color 0.2s ease;
}

.table tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.05);
}

.table td {
  padding: 1rem;
  vertical-align: middle;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

.text-muted {
  font-size: 0.875rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .table {
    font-size: 0.875rem;
  }

  .table td {
    padding: 0.5rem;
  }

  .table-responsive {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AuditLog.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6DAA6D;AAC/D;;AAEA;EACE,yCAAyC;EACzC,sDAAsD;EACtD,qBAAqB;EACrB,iDAAiD;EACjD;yCACuC;EACvC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,uEAAuE;AACvE;EACE;mEACiE;EACjE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,sDAAsD;IACtD,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,kCAAkC;IAClC,SAAS;IACT,6DAA6D;IAC7D,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Audit Log Styles */\r\n\r\n.audit-container {\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n.audit-container h1 {\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid var(--border, rgba(255,255,255,.07));\r\n}\r\n\r\n.table-responsive {\r\n  background-color: var(--bg-card, #0d0f1a);\r\n  border: 1px solid var(--border, rgba(255,255,255,.07));\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.3);\r\n  /* `overflow: hidden` recortaba la tabla ancha sin dar scroll: en un móvil la\r\n     columna «Cambio» era inalcanzable. */\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* En móvil cada registro se lee como ficha: etiqueta a la izquierda. */\r\n@media (max-width: 768px) {\r\n  /* La regla genérica de `overrides.css` da 560 px mínimos a las tablas de\r\n     Bootstrap para que se puedan deslizar; aquí ya está apilada. */\r\n  .audit-container .table-responsive > .table {\r\n    min-width: 0;\r\n  }\r\n\r\n  .audit-container h1 {\r\n    margin-bottom: 1rem;\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .table {\r\n    min-width: 0;\r\n  }\r\n\r\n  .table thead {\r\n    display: none;\r\n  }\r\n\r\n  .table tbody tr {\r\n    display: block;\r\n    margin-bottom: 0.65rem;\r\n    border: 1px solid var(--border, rgba(255,255,255,.07));\r\n    border-radius: 10px;\r\n    background: var(--bg-card, #0d0f1a);\r\n    overflow: hidden;\r\n  }\r\n\r\n  .table td {\r\n    display: flex;\r\n    align-items: baseline;\r\n    justify-content: space-between;\r\n    gap: 0.75rem;\r\n    padding: 0.45rem 0.8rem !important;\r\n    border: 0;\r\n    border-bottom: 1px solid var(--border, rgba(255,255,255,.07));\r\n    text-align: right;\r\n  }\r\n\r\n  .table td:last-child {\r\n    border-bottom: 0;\r\n  }\r\n\r\n  .table td[data-label]::before {\r\n    content: attr(data-label);\r\n    flex: 0 0 auto;\r\n    font-size: 0.68rem;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.06em;\r\n    color: #94a3b8;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.table {\r\n  margin-bottom: 0;\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.table thead {\r\n  background-color: #1e293b;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.table-dark {\r\n  background-color: #1e293b;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.table-dark th {\r\n  border-color: #495057;\r\n}\r\n\r\n.table tbody tr {\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.table tbody tr:hover {\r\n  background-color: rgba(0, 123, 255, 0.05);\r\n}\r\n\r\n.table td {\r\n  padding: 1rem;\r\n  vertical-align: middle;\r\n}\r\n\r\n.badge {\r\n  font-size: 0.75rem;\r\n  padding: 0.35em 0.65em;\r\n}\r\n\r\n.text-muted {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .table {\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .table td {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n  .table-responsive {\r\n    overflow-x: auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
